(async () => {
  const plyrs = Array.from(document.querySelectorAll('.js-plyr-iframe'));
  const plyrInterval = setInterval(() => {
    if (typeof Plyr === 'undefined') {
      return;
    }
    for (const plyr of plyrs) {
      if (!plyr.src) {
        continue;
      }
      initPlyr(new Plyr(plyr.parentNode, { clickToPlay: true, fullscreen: { iosNative: true } }), plyr.parentNode);
    }
    clearInterval(plyrInterval);
  }, 500);

  function initPlyr(player, parent) {
    if (player && parent) {
      parent.addEventListener('click', () => {
        if (window.innerWidth < 1000) {
          if (player.playing) {
            player.pause();
          } else {
            player.play();
          }
        }
      });
      player.on('play', () => {
        parent.querySelector('.plyr__poster').style.zIndex = -1;
        parent.querySelector('.plyr__poster').style.opacity = 0;
        parent.querySelector('.plyr__poster').style.display = 'none';
      });
      player.on('pause', () => {
        parent.querySelector('.plyr__poster').style.zIndex = 2;
        parent.querySelector('.plyr__poster').style.opacity = 1;
        parent.querySelector('.plyr__poster').style.display = 'block';
      });
      player.on('stop', () => {
        parent.querySelector('.plyr__poster').style.zIndex = 2;
        parent.querySelector('.plyr__poster').style.opacity = 1;
        parent.querySelector('.plyr__poster').style.display = 'block';
      });
    }
  }

  window.initPlyr = initPlyr;
})();
